import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ToastType = 'success' | 'error' | 'info' | 'warning';

export type Toast = {
  id: string;
  title: string;
  message: string;
  type: ToastType;
  duration?: number; // ms
};

type TriggerToastPayload = {
  title?: string;
  message?: string;
  type?: ToastType;
  duration?: number;
};

type ToastState = {
  toasts: Toast[];
};

const MAX_TOASTS = 3;
const DEFAULT_TOAST_DURATION = 4000;

const initialState: ToastState = {
  toasts: [],
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    triggerToast: (state, action: PayloadAction<TriggerToastPayload>) => {
      const id = new Date().toISOString();

      if (state.toasts.length >= MAX_TOASTS) {
        state.toasts.shift();
      }

      state.toasts.push({
        id,
        title: action.payload.title || 'Помилка',
        message:
          action.payload.message || 'Щось пішло не так. Спробуйте ще раз.',
        type: action.payload.type || 'error',
        duration: action.payload.duration ?? DEFAULT_TOAST_DURATION,
      });
    },

    removeToast: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter(
        (toast) => toast.id !== action.payload,
      );
    },
  },
});

export const { triggerToast, removeToast } = toastSlice.actions;

export default toastSlice.reducer;
